import { Box, Button, Chip, IconButton, Snackbar, TextField, Typography, useTheme } from '@mui/material';
import { DataGrid } from '@mui/x-data-grid';
import { tokens } from '../../theme';
// import EditIcon from '@mui/icons-material/Edit';
import Header from '../../components/Header';
import ConfirmDeleteDialog from '../../components/ConfirmDeleteDialog';
import DeleteIcon from '@mui/icons-material/Delete';
import CloseIcon from '@mui/icons-material/Close';
import SearchIcon from '@mui/icons-material/Search';
import { useCallback, useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';
import VisibilityIcon from '@mui/icons-material/Visibility';
import StarRating from '../../components/StarRating';
import { filterActionColumns } from '../../utils/permissions';

const UserFeedbacks = () => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const [openToast, setOpenToast] = useState(false);
  const [toastMessage, setToastmessage] = useState('');
  const token = localStorage.getItem('token');

  const [feedback, setFeedback] = useState([]);
  const [loading, setLoading] = useState(false);
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [totalCount, setTotalCount] = useState(0);
  const [searchInput, setSearchInput] = useState('');
  const [search, setSearch] = useState('');
  const [deleteDialogOpen, setDeleteDialogOpen] = useState(false);
  const [idToDelete, setIdToDelete] = useState(null);

  // Debounce the search box so typing doesn't fire a request per keystroke.
  useEffect(() => {
    const t = setTimeout(() => {
      setSearch(searchInput);
      setPage(1);
    }, 300);
    return () => clearTimeout(t);
  }, [searchInput]);

  const getData = useCallback(async () => {
    setLoading(true);
    const params = new URLSearchParams();
    params.set('page', String(page));
    params.set('limit', String(pageSize));
    if (search) params.set('search', search);

    const res = await fetch(`${process.env.REACT_APP_APILINK}/admin/userfeedback?${params.toString()}`, {
      headers: { token },
    });
    const data = await res.json();
    if (data.success) {
      setFeedback(data.data);
      setTotalCount(data.pagination?.total ?? data.data.length);
    }
    setLoading(false);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [page, pageSize, search]);

  useEffect(() => {
    getData();
  }, [getData]);

  const handleClearSearch = () => {
    setSearchInput('');
    setSearch('');
    setPage(1);
  };

  // Delete passenger feedback
  const handleDelete = async (id) => {
    const res = await fetch(`${process.env.REACT_APP_APILINK}/admin/userfeedback/${id}`, {
      method: 'DELETE',
      headers: { token },
    });
    const data = await res.json();
    if (data.message) {
      setOpenToast(true);
      setToastmessage(data.message);
      if (data.success) {
        getData();
      }
    }
  };

  const openDeleteDialog = (id) => {
    setIdToDelete(id);
    setDeleteDialogOpen(true);
  };

  const closeDeleteDialog = () => {
    setDeleteDialogOpen(false);
    setIdToDelete(null);
  };

  const confirmDelete = async () => {
    if (idToDelete == null) return;
    await handleDelete(idToDelete);
    closeDeleteDialog();
  };

  const columns = [
    {
      field: 'passenger',
      headerName: 'Passenger',
      flex: 1,
      minWidth: 100,
      cellClassName: 'name-column--cell',
    },
    {
      field: 'email',
      headerName: 'Email',
      flex: 1,
      minWidth: 150,
      cellClassName: 'name-column--cell',
    },
    {
      field: 'CountryName',
      headerName: 'Destination',
      flex: 1,
      minWidth: 100,
      cellClassName: 'name-column--cell',
    },
    {
      field: 'guide',
      headerName: 'Guide',
      flex: 1,
      minWidth: 100,
      cellClassName: 'name-column--cell',
    },
    {
      field: 'partner',
      headerName: 'Partner',
      flex: 1,
      minWidth: 100,
      cellClassName: 'name-column--cell',
    },
    {
      field: 'avg_rating',
      headerName: 'Rating',
      flex: 1,
      minWidth: 100,
      filterable: false,
      cellClassName: 'name-column--cell',
      renderCell: (cellValues) => {
        return <StarRating value={cellValues.row.avg_rating} />;
      },
    },
    {
      field: 'View',
      filterable: false,
      renderCell: (cellValues) => {
        return (
          <Link to={`/userfeedback/${cellValues.row.feedback_id}`}>
            <Button
              sx={{
                backgroundColor: colors.blueAccent[600],
                color: colors.grey[100],
                ':hover': { backgroundColor: colors.blueAccent[700] },
              }}
              variant="contained"
            >
              <VisibilityIcon />
            </Button>
          </Link>
        );
      },
    },
    {
      field: 'Delete',
      filterable: false,
      renderCell: (cellValues) => {
        return (
          <Button
            sx={{
              backgroundColor: colors.redAccent[500],
              color: colors.grey[100],
              ':hover': { backgroundColor: colors.redAccent[600] },
            }}
            variant="contained"
            onClick={() => openDeleteDialog(cellValues.row.feedback_id)}
          >
            <DeleteIcon />
          </Button>
        );
      },
    },
  ];

  // Toast
  const handleCloseToast = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setOpenToast(false);
  };

  const action = (
    <>
      <IconButton size="small" aria-label="close" color="inherit" onClick={handleCloseToast}>
        <CloseIcon fontSize="small" />
      </IconButton>
    </>
  );

  return (
    <Box m="20px">
      <Box display="flex" justifyContent="space-between" alignItems="center">
        <Header title="PASSENGER FEEDBACKS" subtitle="View all Passengers Feedbacks" />

        {/* <Box>
          <Link to={'/userfeedback/addfeedback'}>
            <Button
              sx={{
                backgroundColor: colors.blueAccent[700],
                color: colors.grey[100],
                fontSize: '14px',
                fontWeight: 'bold',
                padding: '10px 20px',
                '&:hover': {
                  backgroundColor: colors.blueAccent[800],
                },
              }}
            >
              <HelpOutlineIcon sx={{ mr: '10px' }} />
              Add Feedback
            </Button>
          </Link>
        </Box> */}
      </Box>

      <Box display="flex" gap="10px" flexWrap="wrap" alignItems="center" m="10px 0 0 0">
        <TextField
          size="small"
          placeholder="Search by passenger, email, destination, guide, partner..."
          value={searchInput}
          onChange={(e) => setSearchInput(e.target.value)}
          InputProps={{
            startAdornment: <SearchIcon sx={{ mr: 1, color: colors.grey[300] }} />,
          }}
          sx={{ minWidth: '340px', backgroundColor: colors.primary[400] }}
        />
      </Box>

      {search && (
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, flexWrap: 'wrap', mt: 1, mb: 1 }}>
          <Typography variant="body2" sx={{ color: colors.grey[300], fontWeight: 500 }}>
            Active filters:
          </Typography>
          <Chip
            label={`Search: ${search}`}
            size="small"
            onDelete={handleClearSearch}
            sx={{ backgroundColor: colors.blueAccent[700], color: colors.grey[100], '& .MuiChip-deleteIcon': { color: colors.grey[300] } }}
          />
          {!loading && (
            <Typography variant="body2" sx={{ color: colors.greenAccent[400], ml: 1 }}>
              {totalCount} result{totalCount !== 1 ? 's' : ''}
            </Typography>
          )}
          <Typography
            variant="body2"
            onClick={handleClearSearch}
            sx={{
              color: colors.redAccent[500],
              cursor: 'pointer',
              ml: 1,
              '&:hover': { textDecoration: 'underline' },
            }}
          >
            Clear all
          </Typography>
        </Box>
      )}

      <Box
        m="10px 0 0 0"
        height="667px"
        sx={{
          '& .MuiDataGrid-root': {
            border: 'none',
          },
          '& .MuiDataGrid-cell': {
            borderBottom: 'none',
          },
          '& .name-column--cell': {
            color: colors.grey[100],
          },
          '& .MuiDataGrid-columnHeaders': {
            backgroundColor: colors.blueAccent[700],
            borderBottom: 'none',
          },
          '& .MuiDataGrid-virtualScroller': {
            backgroundColor: colors.primary[400],
          },
          '& .MuiDataGrid-footerContainer': {
            borderTop: 'none',
            backgroundColor: colors.blueAccent[700],
          },
          '& .MuiCheckbox-root': {
            color: `${colors.greenAccent[200]} !important`,
          },
          '& .MuiDataGrid-toolbarContainer .MuiButton-text': {
            color: `${colors.grey[100]} !important`,
            fontSize: 14,
          },
        }}
      >
        <DataGrid
          rows={feedback}
          columns={filterActionColumns(columns, { Delete: 'user_feedback.delete' })}
          getRowId={(row) => row.feedback_id}
          disableColumnFilter
          loading={loading}
          pagination
          paginationMode="server"
          page={page - 1}
          pageSize={pageSize}
          rowCount={totalCount}
          rowsPerPageOptions={[10, 25, 50, 100]}
          onPageChange={(newPage) => setPage(newPage + 1)}
          onPageSizeChange={(newPageSize) => {
            setPageSize(newPageSize);
            setPage(1);
          }}
        />
      </Box>

      <ConfirmDeleteDialog
        open={deleteDialogOpen}
        onClose={closeDeleteDialog}
        onConfirm={confirmDelete}
        title="Delete passenger feedback?"
        message="Are you sure you want to delete this passenger feedback?"
        colors={colors}
      />

      <Snackbar
        open={openToast}
        autoHideDuration={5000}
        onClose={handleCloseToast}
        message={toastMessage}
        action={action}
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
      />
    </Box>
  );
};

export default UserFeedbacks;
